import { action } from 'satcheljs';

/**
 * Action to enable/disable a booking service from the store.
 */
let enableDisableService = action(
    'ENABLE_DISABLE_PBP_SERVICE',
    (serviceId: string, enable: boolean) => ({
        serviceId,
        enable,
    })
);

export default enableDisableService;
